import { connect as formConnect, FieldArray } from 'formik';
import React, { useState } from 'react';
import { Clock, Mail, Settings } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button } from '../../components/Button';
import { FeatherButton } from '../../components/FeatherButton';
import { findOptions } from '../../components/FloatingPlaceholder';
import { Loader } from '../../components/Loader';
import { PTInfo, PTInputCheckboxBasic, PTInputSelectBasic, PTSwitch } from '../../components/PTElements';
import { PTModal } from '../../components/PTModal';
import { choreTypes } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from '../../redux/clients';
import './ClientChores.css';


const ClientChores = ({ formik: { values, setFieldValue }, ...props }) => {
    const renderChoreCategory = (cat, index) => {
        var actualCat = EVO.firstOrDefault(choreTypes, ct => ct.value + '' === cat.key);
        if (!actualCat) return null;
        return <div key={cat.key}>
            <div className="chore-title">{actualCat.label}</div>
            {actualCat.description && <div className="chore-subtitle">{actualCat.description}</div>}
            <div className="chore-wrapper">
                {cat.values.map(v => <Chore chore={v} key={v.id} setFieldValue={setFieldValue} values={values} />)}
            </div>
        </div>
    }

    return (<div id="client-chores">
        <Loader loading={props.client.isCmClient && props.loadingDetails}>
            <div>
                

                {
                    props.client.chores && props.client.chores.length > 0 &&
                    (<FieldArray name="chores" render={arrayHelpers => EVO.groupBy(props.client.chores, c => c.choreTypeId).map(renderChoreCategory)} />)
                }


            </div>
        </Loader>
    </div>
    );
}

const C = ({ chore, setFieldValue, values, ...props }) => {
    let prop = '';
    let options = [];
    if (chore.choreTypeId === 1) {
        prop = 'cmEmailId';
        options = props.cmEmails;
    }
    else if (chore.choreTypeId === 2) {
        prop = 'cmSegmentId';
        options = props.cmSegments;
    }
    else if (chore.choreTypeId === 3) {
        prop = 'cmSubscriptionListId';
        options = props.cmLists;
    }
    const name = `chores[${chore.index}].${prop}`;
    const defined = !!chore[prop];
    const [open, setOpen] = useState(defined && chore.active);
    const [sendingEmail, setSendingEmail] = useState(false);

    var data = {
        id: props.client.id,
        choreId: chore.choreId,
        active: chore.active
    };

    const changeEnabled = () => {
        const active = `chores[${chore.index}].active`;
        if (open) {
            setFieldValue(active, false);
            setOpen(false);
            data.active = false;
            data[prop] = chore[prop];
            props.updateTransactionalEmail(data);
        }
        else if (chore[prop]) {
            setFieldValue(active, true);
            setOpen(true);
            data.active = true;
            data[prop] = chore[prop];
            props.updateTransactionalEmail(data);
        }
        else {
            showChore();
        }
    };

    const sendEmail = () => {
        if (!open || sendingEmail)
            return;

        setSendingEmail(true);
        EVO.post('/api/clients/senddummyemail', data).then(r => {
            let message = 'Email Sent';
            if (r.email) {
                message += ' to ' + r.email;
            }
            EVO.success(message);
            setSendingEmail(false);
        }).catch(e => {
            setSendingEmail(false);
        });
    };

    const updateField = (selectedOption, attachIcsFile, callback) => {
        data[prop] = selectedOption;
        data.attachIcsFile = attachIcsFile;
        data.updating = true;
        props.updateTransactionalEmail(data)
            .then(() => {
                setFieldValue(name, selectedOption);
                setFieldValue(`chores[${chore.index}].attachIcsFile`, attachIcsFile);
                setOpen(!!selectedOption);
                callback();
                EVO.closeModal();
            });
    }

    const showChore = () => {
        EVO.modal(<PTModal>
            <ChoreModal actualChore={actualChore} prop={prop} name={name} options={options} value={chore[prop]} chore={chore} updateField={updateField} />
        </PTModal>);
    };

    const actualChore = EVO.firstOrDefault(props.chores, c => c.id === chore.choreId);
    if (actualChore && (!EVO.any(actualChore.tags) || EVO.any(values.tags, t => actualChore.tags.includes(t)))) {
        return (
            <div key={actualChore.id}>
                <div className="chore-name-wrapper">
                    <div>
                        {EVO.any(actualChore.tags) && <div className="chore-name-tags">
                            {actualChore.tags.map(t => <span key={t}>{t}</span> )}
                        </div>}
                        <span className="chore-name">{actualChore.name}</span>
                        <div>{(findOptions(options, { value: chore[prop] }) || {}).label}</div>
                    </div>
                    <div className="chore-name-buttons">
                        {open && <div className="chore-name-sendemail" onClick={sendEmail} ><span>Send test</span><FeatherButton feather={sendingEmail ? <Clock /> : <Mail />}/></div>}
                        <PTSwitch onChange={changeEnabled} checked={open} />
                        <FeatherButton feather={<Settings />} onClick={() => showChore(actualChore)} />
                        {actualChore.tooltip && <PTInfo info={actualChore.tooltip} />}
                    </div>
                </div>
            </div>);
    }

    return null;
}

const selectStyles = {
    menuPortal: s => ({
        ...s,
        zIndex: 99999
    })
};

const ChoreModal = ({ actualChore, prop, value, options, updateField, chore }) => {
    const [selectedOption, setSelectedOption] = useState(value);
    const [attachIcsFile, setAttachIcsFile] = useState(chore.attachIcsFile);
    const [loading, setLoading] = useState(false);

    const handleOk = () => {
        if (loading) return;
        setLoading(true);
        updateField(selectedOption, attachIcsFile, () => {
            setLoading(false);
        });
    };

    const icsChange = e => {
        setAttachIcsFile(e.value);
    };

    return <div className="chore-modal">
        <h3>{actualChore.name}</h3>
        <span className="chore-modal-info">To edit a template go to the Send Email tab and click on ‘Transactional’ in the top menu. <a href="https://help.peptalkr.com.au/en/articles/4151881-how-to-edit-your-transactional-email-content" target="_blank" rel="noopener noreferrer">More info</a></span>
        <div>
            <PTInputSelectBasic
                field={{ name: prop, value: selectedOption }}
                options={options}
                classNamePrefix="pt-input-select"
                placeholder="Select..."
                styles={selectStyles}
                menuPortalTarget={document.body}
                onChange={e => setSelectedOption(e.value)}
            />

            {actualChore.taskName === 1 &&
                <div className="attach-ics">
                <PTInputCheckboxBasic
                    field={{ name: 'attachIcsFile', value: attachIcsFile }}
                    onChange={e => icsChange(e)}
                    placeholder="Attach ICS file for appointment"
                />
                </div>
            }
        </div>
        <Button text="Ok" loading={loading} onClick={handleOk} />
    </div>
}


const mapStateToProps = ({ clients }) => ({
    client: clients.client,
    chores: clients.chores,
    cmEmails: clients.cmEmails,
    cmSegments: clients.cmSegments,
    cmLists: clients.cmLists,
    allTags: clients.allTags,
    loadingDetails: clients.loadingDetails,
    error: clients.error
});

const Chore = connect(mapStateToProps, actions)(C);
export default formConnect(connect(mapStateToProps, actions)(withRouter(ClientChores)));


// WEBPACK FOOTER //
// ./src/pages/Clients/ClientChores.js